/* =========================================
   LP METAL DETECTING - COPY PRICE MATCH
   ========================================= */

(function () {
  'use strict';

  function initLPPriceMatch() {

    // Only run on Shopify product pages
    if (!window.location.pathname.startsWith('/products/')) {
      return;
    }

    // Prevent loading twice
    if (document.getElementById('lp-price-match')) {
      return;
    }

    // Find the product title
    const titleElement =
      document.querySelector('h1.product-meta__title') ||
      document.querySelector('.product-meta__title') ||
      document.querySelector('h1');

    if (!titleElement) {
      return;
    }

    const productTitle = titleElement.textContent.trim();

    if (!productTitle) {
      return;
    }

    // Price match email address
    const priceMatchEmail = 'info@lpmetaldetecting.com';


    /* =========================================
       CREATE POPUP
       ========================================= */

    const popup = document.createElement('div');

    popup.id = 'lp-price-match';

    popup.innerHTML = `
      <div class="lp-price-match-overlay"></div>

      <div
        class="lp-price-match-box"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lp-price-match-title"
      >

        <button
          class="lp-price-match-close"
          type="button"
          aria-label="Close price match message"
        >
          &times;
        </button>

        <h3 id="lp-price-match-title">
          Found it cheaper? We'll match it.
        </h3>

        <p>
          Found a better advertised price from another UK metal detecting retailer?
          Let us know and we'll see if we can match it.
        </p>

        <div class="lp-price-match-actions">

          <a
            class="lp-price-match-button"
            href="#"
          >
            REQUEST A PRICE MATCH
          </a>

          <button
            class="lp-price-match-dismiss"
            type="button"
          >
            Continue shopping
          </button>

        </div>

      </div>
    `;


    /* =========================================
       POPUP STYLING
       ========================================= */

    const style = document.createElement('style');

    style.textContent = `

      #lp-price-match {
        display: none;
        position: fixed;
        inset: 0;
        z-index: 999999;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
      }

      #lp-price-match.lp-show {
        display: flex;
      }

      .lp-price-match-overlay {
        position: absolute;
        inset: 0;
        background: rgba(8, 16, 32, 0.35);
      }

      .lp-price-match-box {
        position: relative;
        z-index: 2;
        width: 100%;
        max-width: 560px;
        background: #ffffff;
        border-radius: 8px;
        padding: 30px 32px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.18);
        color: #101828;
        box-sizing: border-box;
        animation: lpPriceMatchIn 0.18s ease-out;
      }

      @keyframes lpPriceMatchIn {

        from {
          opacity: 0;
          transform: translateY(8px);
        }

        to {
          opacity: 1;
          transform: translateY(0);
        }

      }

      .lp-price-match-box h3 {
        margin: 0 40px 10px 0;
        color: #203584;
        font-size: 22px;
        line-height: 1.3;
        font-weight: 700;
      }

      .lp-price-match-box p {
        margin: 0 0 22px;
        color: #475467;
        font-size: 15px;
        line-height: 1.55;
      }

      .lp-price-match-actions {
        display: flex;
        align-items: center;
        gap: 18px;
        flex-wrap: wrap;
      }

      .lp-price-match-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #b5a079;
        color: #ffffff !important;
        text-decoration: none !important;
        font-size: 13px;
        font-weight: 700;
        padding: 13px 20px;
        border-radius: 2px;
        letter-spacing: 0.2px;
      }

      .lp-price-match-button:hover {
        opacity: 0.9;
      }

      .lp-price-match-dismiss {
        appearance: none;
        border: 0;
        background: transparent;
        padding: 8px 0;
        cursor: pointer;
        color: #475467;
        font: inherit;
        font-weight: 600;
      }

      .lp-price-match-dismiss:hover {
        text-decoration: underline;
      }

      .lp-price-match-close {
        position: absolute;
        right: 16px;
        top: 14px;
        border: 0;
        background: transparent;
        color: #667085;
        cursor: pointer;
        font-size: 26px;
        line-height: 1;
        padding: 5px;
      }


      /* =========================================
         MOBILE
         ========================================= */

      @media (max-width: 600px) {

        #lp-price-match {
          padding: 18px;
        }

        .lp-price-match-box {
          max-width: 390px;
          padding: 24px 22px 20px;
          border-radius: 8px;
        }

        .lp-price-match-box h3 {
          margin: 0 35px 8px 0;
          font-size: 19px;
          line-height: 1.25;
        }

        .lp-price-match-box p {
          margin: 0 0 18px;
          font-size: 14px;
          line-height: 1.45;
        }

        .lp-price-match-actions {
          flex-direction: column;
          align-items: stretch;
          gap: 6px;
        }

        .lp-price-match-button {
          width: 100%;
          box-sizing: border-box;
          padding: 12px 16px;
          font-size: 13px;
        }

        .lp-price-match-dismiss {
          padding: 9px 0 2px;
          font-size: 13px;
        }

        .lp-price-match-close {
          top: 12px;
          right: 12px;
          font-size: 23px;
        }

      }

    `;


    document.head.appendChild(style);
    document.body.appendChild(popup);


    /* =========================================
       ELEMENTS
       ========================================= */

    const emailButton =
      popup.querySelector('.lp-price-match-button');

    const closeButton =
      popup.querySelector('.lp-price-match-close');

    const dismissButton =
      popup.querySelector('.lp-price-match-dismiss');

    const overlay =
      popup.querySelector('.lp-price-match-overlay');


    /* =========================================
       OPEN POPUP
       ========================================= */

    function openPopup() {

      // Only show once during this browsing session
      if (sessionStorage.getItem('lpPriceMatchShown')) {
        return;
      }


      /* EMAIL SUBJECT */

      const subject =
        'Price Match Request - ' + productTitle;


      /* EMAIL BODY */

      const body =
        'Hi LP,\r\n\r\n' +

        'I have found a better advertised price for:\r\n' +
        productTitle +
        '\r\n\r\n' +

        'LP product:\r\n' +
        window.location.href +
        '\r\n\r\n' +

        'Competitor/link:\r\n\r\n' +

        'Price found: £\r\n\r\n' +

        'Thanks';


      /* BUILD EMAIL LINK */

      emailButton.href =
        'mailto:' +
        priceMatchEmail +
        '?subject=' +
        encodeURIComponent(subject) +
        '&body=' +
        encodeURIComponent(body);


      /* SHOW POPUP */

      popup.classList.add('lp-show');


      /* REMEMBER WE SHOWED IT */

      sessionStorage.setItem(
        'lpPriceMatchShown',
        'true'
      );

    }


    /* =========================================
       CLOSE POPUP
       ========================================= */

    function closePopup() {

      popup.classList.remove('lp-show');

    }


    closeButton.addEventListener(
      'click',
      closePopup
    );


    dismissButton.addEventListener(
      'click',
      closePopup
    );


    overlay.addEventListener(
      'click',
      closePopup
    );


    /* ESC KEY */

    document.addEventListener(
      'keydown',
      function (event) {

        if (event.key === 'Escape') {
          closePopup();
        }

      }
    );


    /* =========================================
       DETECT PRODUCT TITLE COPY
       ========================================= */

    document.addEventListener(
      'copy',
      function () {

        const selection =
          window.getSelection();

        if (!selection) {
          return;
        }


        const copiedText =
          selection
            .toString()
            .trim();


        if (!copiedText) {
          return;
        }


        const copied =
          copiedText.toLowerCase();


        const title =
          productTitle.toLowerCase();


        /*
          Trigger if:

          1. The customer copies the whole title

          OR

          2. They copy a meaningful section
             of the product title (10+ characters)
        */

        if (
          copied.includes(title) ||
          (
            title.includes(copied) &&
            copied.length >= 10
          )
        ) {

          /*
            Small delay allows the normal
            clipboard copy to finish first.
          */

          setTimeout(
            openPopup,
            50
          );

        }

      }
    );

  }


  /* =========================================
     START
     ========================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initLPPriceMatch
    );

  } else {

    initLPPriceMatch();

  }

})();